export const MAIN_SET_FEEDBACK = 'MAIN_SET_FEEDBACK'
export const MAIN_SET_FETCHING = 'MAIN_SET_FETCHING'
export const MAIN_SET_ACCESSIBILITY = 'MAIN_SET_ACCESSIBILITY'
export const MAIN_SET_LANGUAGE = 'MAIN_SET_LANGUAGE'
export const MAIN_SET_FONTSIZE = 'MAIN_SET_FONTSIZE'
export const MAIN_SET_FULLSCREEN = 'MAIN_SET_FULLSCREEN'
